module.exports = __webpack_public_path__ + "static/media/Huncha diid.5275130d.wav";